<template>
    <div class="link-list-block">
        <h5>
            {{ title }}
        </h5>
        <ul class="white">
            <li
                v-for="(link, i) in links"
                :key="i"
            >
                <a
                    v-if="typeof link[0] === 'string'"
                    :href="link[1]"
                    target="_blank"
                >
                    {{ link[0] }}
                </a>
                <template v-else>
                    <template v-for="(linkPart, ii) of link">
                        <a
                            v-if="linkPart[1]"
                            :key="ii"
                            :href="linkPart[1]"
                            target="_blank"
                        >{{ linkPart[0] }}</a>
                        <span
                            v-else
                            :key="ii"
                        >{{ linkPart[0] }}</span>
                    </template>
                </template>
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'Block',
    props: {
        title: {
            type: String,
            required: true
        },
        links: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" src="./Block.scss" />
